import React, { useState } from 'react'
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  FormControl,
  DropdownButton,
  FloatingLabel,
  Dropdown,
  Table,
  Alert,
  FormSelect
} from 'react-bootstrap'


import { useForm } from 'react-hook-form'
import { CONFIG } from '../../config/constant'
import { BASE } from '../../basedata/constants'
import DatePicker, { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'

registerLocale('pt-br', ptBR)

import 'react-datepicker/dist/react-datepicker.css'

import clubLogo from '../../images/club_logo.png'
import bentoLogo from '../../assets/images/logo_sao_bento.png'
import userTest from '../../assets/images/user/jeff_test.jpeg'
import netTest from '../../assets/images/user/neg.jpeg'
import Loader from '../../shared/loader'
import { fetchWithApiKey } from '../../config/apiCall'
import UserBiometryImage from './UserBiometryImage'
import { apiAuth } from './ApiCall'

const maskCPF = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

// (00) 00000-0000
const maskPhone = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d{4})(\d)/, '$1-$2')
}

// 00000-000
const maskCEP = (value: any) => {
  return value.replace(/\D/g, '').replace(/^(\d{5})(\d{3})+?$/, '$1-$2')
}

// 00/00/0000
const maskDate = (value: any) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

const isValidEmail = (email: any) =>
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  )

const strongPassword = (password: any) => {
  return /(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
    password
  )
}

interface Props {
  onResponse: (response: any) => void
}

const SearchTicket = ({ onResponse }: Props) => {

  const auth = sessionStorage.getItem('auth')

  const currentGate = sessionStorage.getItem('gate')

  if (auth !== 'true') {
    window.location.href = '/'
  }

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues,
    reset
  } = useForm()

  const [startDate, setStartDate] = useState(new Date())

  const [hasToken, setHasToken] = useState('')

  const [disableSign, setDisableSign] = useState(false)

  const [userNotFound, setUserNotFound] = useState(false)

  const [motivation, setMotivation] = useState({
    show: false,
    case: 0,
    ticketId: '',
    token: ''
  })

  const [loading, setLoading] = useState(false)

  const [userData, setUserData] = useState({
    image: '---',
    name: '',
    documentType: '',
    document: '',
    birthday: '',
    transaction: '',
    game: '',
    gameTime: '',
    status: '',
    sector: '',
    gate: '',
    block: '',
    row: '',
    sit: '',
    ticketStatus: '',
    ticketUsed: {
      date: '',
      time: '',
      gate: ''
    },
    ticket: [{
      validTo: '',
      validFrom: '',
      status: '',
      sessionDate: '',
      sessionId: '',
      sessionTime: '',
      gate: '',
      checkInLogs: { createdAt: '', hash: '', sector: '' },
      tokens: [{ type: '', token: '', active: false }]
    }],
    ingPortao: '',
    supervisor: false,
    ticketHistory: [] as any[]
  })

  const [searchUser, setSearchUser] = useState('')

  const [newUser, setNewUser] = useState({
    login: '',
    password: '',
    set: false
  })

  const [game, setGame] = useState('');
  const [gameTime, setGameTime] = useState('');
  const [canCleanDocuments, setCanCleanDocuments] = useState(['01875843620', '07018132452'])


  const onSubmit = (data: any) => {

    sessionStorage.removeItem('ticket')
    sessionStorage.removeItem('usedTicket')

    setUserNotFound(false)
    setSearchUser('')
    setLoading(true)
    fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.user_validate}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        value: data.document.replace(/\./g, '').replace(/-/g, '').replace(/^\s+|\s+$/g, ''),
        search: data.type,
      })
    })
      .then((res) => res.json())
      .then((response) => {
        setLoading(false)
        if (!response.document) {
          return setUserNotFound(true)
        }

        setUserNotFound(false)

        setGame(response.game || '-')
        setGameTime(response.gameTime || '-')

        sessionStorage.setItem('ticket', response.ticket.hash)
        sessionStorage.setItem('gameCode', (response.gameCode || '1111'))
        sessionStorage.setItem('document', response.document)
        sessionStorage.setItem('tokenBiometric', response.token)
        if (response.ticketStatus === 'valid' || response.ticketStatus === 'discounted') {
          sessionStorage.setItem('usedTicket', 'true')
        }
        const ticketNormalized = Array.isArray(response.ticket)
          ? response.ticket
          : response.ticket
            ? [response.ticket]
            : []

        setUserData({
          ...response,
          ticket: ticketNormalized
        })

        setSearchUser(response.document)

        console.log(response.ingPortao)
        return false
      })

      .catch((error) => {
        console.log(error)
        if(data.refreshAttempts > 1){
          setLoading(false)
          setUserNotFound(true)
          return false
        }
        refreshAndResubimit(data)
      })
  }

  const refreshAndResubimit = async (data: any) => {
    data = {...data, refreshAttempts: 2}
    const refreshToken = sessionStorage.getItem('refreshToken')

    try{
      let refreshAccess: any = await apiAuth.post(`/auth/refresh-token`,
        {},
        {
          headers: {
            'x-refresh-token': refreshToken || '',
          }
        }
      )


      if(refreshAccess.data && refreshAccess.data.refresh_token){
        refreshAccess = refreshAccess.data
        sessionStorage.setItem('user-key', JSON.stringify({user_key: refreshAccess?.token, tenant_id: 'flamengo-zjbgi'}))
        sessionStorage.setItem('refreshToken', refreshAccess?.refresh_token)
      }

      onSubmit(data)
    }catch(e){
      alert('Sua sessão expirou')
      sessionStorage.clear()
      window.location.href= '/'
    }
  }


  const motivationSubmit = (data: any) => {
    sessionStorage.setItem('reason', data.case)
    onResponse(1)
  }

  const sendWrongGate = (wrongTicket: any, wrongGate: any) => {
    fetchWithApiKey(`${BASE.ticket_api.base_url}${BASE.ticket_api.generateAccess}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': BASE.api.api_key
      },
      body: JSON.stringify({
        "ticket": wrongTicket,
        "gate": wrongGate,
        "deviceIp": "0.0.0.0",
        "registeredFace": "wrongGate",
        'status': 'waiting'
      })
    })
      .catch((error) => {
        console.log(error)
      })
  }
  const resetForm = () => {
    setNewUser({
      login: '',
      password: '',
      set: false
    })
    setHasToken('')
    setDisableSign(false)
    reset()
  }

  const dateFormatter = (dateTime:string)=>{

    const options:any = {
      year: '2-digit',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC'
    };

    const oldDate = new Date(dateTime)
    return oldDate.toLocaleDateString('pt-BR', options).split(',').join(' ')
  }

  if (loading) {
    return (<Loader />)
  }

  if (motivation.show) {
    return (
      <Form onSubmit={handleSubmit(motivationSubmit)}>
        <Table responsive striped >
          <tbody>
            <tr>
              <td>Foto</td>
            </tr>
            <tr>
            <td><UserBiometryImage imagePath={userData.image} imageSide={'face'} /></td>
            </tr>
            <tr>
              <td>Qual o motivo da contingência?</td>
            </tr>
            <tr>
              <td className='reason-radios'>

                <Form.Check
                  {...register('case', { required: true })}
                  label="Leitor não reconheceu a face do torcedor"
                  name="case"
                  type="radio"
                  value="1"
                  id={`1`}
                />
                {/*<Form.Check*/}
                {/*  {...register('case', { required: true })}*/}
                {/*  label="Foto de outra pessoa"*/}
                {/*  name="case"*/}
                {/*  type="radio"*/}
                {/*  value="2"*/}
                {/*  id={`2`}*/}
                {/*/>*/}
                <Form.Check
                  {...register('case', { required: true })}
                  label="CRIANÇA/IDOSO"
                  name="case"
                  type="radio"
                  value="3"
                  id={`3`}
                />
                <Form.Check
                  {...register('case', { required: true })}
                  label="Foto Ruim"
                  name="case"
                  type="radio"
                  value="4"
                  id={`4`}
                />
                <Form.Check
                  {...register('case', { required: true })}
                  label="PCR/PMR"
                  name="case"
                  type="radio"
                  value="5"
                  id={`5`}
                />
                {errors.case && (
                  <span className="label-error">
                    Você precisa escolher uma causa
                  </span>
                )}

              </td>
            </tr>
            <tr>
              <td>
                <Button
                  disabled={disableSign}
                  type="submit"
                  className="mb-0 w-100"
                >
                  Prosseguir
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Form>
    )
  }

  const clearEntrance = async (document:any, host:any) => {
    window.open(`http://${host}:3912/tickets/resetEntrnace/${document}, '_blank'`)
    alert('Entrada Resetada')
  }

  const changeGate = (gate: string) => {
    sessionStorage.setItem('gate', gate)
    window.location.reload()
  }

  const gateMap: Record<string, string> = {
    'K,M,O': 'Gramado Leste (K,M,O)',
    'K3,M3,O1': 'Gramado Leste (K3,M3,O1)',
    'B,D,Y': 'Gramado Oeste (B,D,Y)',
    'B1,D1,Y3': 'Gramado Oeste (B1,D1,Y3)',
    'F,H': 'Gramado Sul (F,H)',
    'F01,H03': 'Gramado Sul (F01,H03)',
    'L,P': 'Superior Leste (L,P)',
    'L1,L2,P1': 'Superior Leste (L1,L2,P1)',
    'E': 'Superior Sul (E)',
    'Q,S,U,W': 'Arquibancada Norte (Q,S,U,W)',
    'Q7,S6,U1,W1': 'Arquibancada Norte (Q7,S6,U1,W1)',
    'C,X': 'Superior Oeste (C,X)',
    'C1,X1': 'Superior Oeste (C1,X1)',
    'R,V': 'Superior Norte (R,V)',
    'R1,V5': 'Superior Norte (R1,V5)',
    'A,G,N': 'Arquibancada Gold (A,G,N)',
    'A4,G4,N4': 'Arquibancada Gold (A4,G4,N4)',
    'Portão 6': 'Visitante (Portão 6)',
    'Conselheiros': 'Conselheiros',
    'Camarote Imortal': 'Camarote Imortal'
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  return (
    <>
      <select
      className="form-control btn btn-default mb-0 w-100"
      onChange={(event) => changeGate(event.target.value)}
    >
      <option>Portão Atual {gateMap[currentGate as string] || 'N/A'}</option>
      {Object.entries(gateMap).map(([value, label]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>


      <Row>
        <Col>
          <Card>
            <Card.Header>
              <Card.Title as="h5">
                <span className='club-header'>
                  Grêmio Controle de acesso v1.9
                </span>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row className="mb-3">
                      <Col>
                        <Form.Label>Tipo do documento</Form.Label>
                        <FormSelect
                          className="form-control"

                          onChange={(event) => {
                            const { value } = event.target
                            // setReportType(value)
                          }}
                        >
                          <option value="access">CPF</option>
                          <option value="signup">Outro</option>
                        </FormSelect>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <Form.Label>Número do documento</Form.Label>
                        <Form.Control placeholder="Número do documento" {...register('document')} />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group>
                          <Button
                            disabled={disableSign}
                            type="submit"
                            className="mb-0 w-100"
                          >
                            Pesquisar
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>

              {newUser.set && (
                <>
                  <hr />
                  <Row>
                    <Col className="qr-wrapper">
                      <h3>Aprovador cadastrado com sucesso!</h3>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>
          </Card></Col>
      </Row>
      {userNotFound && <Row>

        <Col>
          <Alert className='text-center' variant='danger'>Não encontrado</Alert>
        </Col>
      </Row>
      }
      {(canCleanDocuments.includes(userData.document)) && (
<>

          <Button
              disabled={disableSign}
              type="submit"
              className={`ticket-action yellow`}
              onClick={() => {
                clearEntrance(userData.document, '10.0.8.163')
              }}
            >
              Limpar Acesso Dia
            </Button>
            <Button
              disabled={disableSign}
              type="submit"
              className={`ticket-action purple`}
              onClick={() => {
                clearEntrance(userData.document, '10.0.8.170')
              }}
            >
              Limpar Acesso Noite
            </Button>
            </>
          )}
      {searchUser && <Row>
        <Col>
          <Card>
            <Card.Header>
              <Card.Title as="h5">
                <span className='club-header'>Dados do Ingresso</span>
              </Card.Title>
            </Card.Header>
            <Table responsive striped>
              <tbody>
                {(userData.ticketHistory && userData.ticketHistory.length > 0
                  ? userData.ticketHistory
                  : userData.ticket || []
                ).map((t: any, index: number) => (
                  <tr key={t.sessionId || t.id || index}>
                    <th>Ingresso:</th>
                    <td>{t.tokens?.[0]?.token || '-'}</td>
                   <th>Portão:</th>
                   <td>{gateMap[t.gateId] || gateMap[t.gate] || t.gateId || t.gate || '-'}</td>
                    <th>Data e hora da partida</th>
                    <td>{userData.gameTime ? formatDate(userData.gameTime) : '-'}</td>
                    <th className={t.checkInLogs ? 'checked' : ''}>Check-in:</th>
                    <td className={t.checkInLogs ? 'checked' : ''}>
                      {t.checkInLogs ? dateFormatter(t.checkInLogs.createdAt) : 'Não Feito'}
                    </td>

                    <td>
                      <Button
                        disabled={disableSign}
                        type="button"
                        className={`ticket-action ${t.checkInLogs ? 'red' : ''}`}
                        onClick={() => {
                          const token = t.tokens?.[0]?.token
                          
                          if (token) {
                            sessionStorage.setItem('ticket', token)
                            sessionStorage.setItem('gate', t.gateId || t.gate || '-')
                            sessionStorage.setItem('sectorId', (t as any).sectorId || '-')
                            sessionStorage.setItem('sessionId', String(t.sessionId || t.id) || '-')
                          }

                          setMotivation({
                            show: true,
                            case: 0,
                            ticketId: t.sessionId || t.id,
                            token: token
                          })
                        }}
                      >
                        {t.checkInLogs ? 'Acesso Já utilizado' : 'Gerar Acesso'}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {userData.ticketStatus === 'invalid' &&
              <Table responsive striped>
                <tbody>
                <tr className='text-center'>
                  <td>Utilização</td>
                </tr>
                <tr>
                  <td className='text-center'>
                    {userData.ticketUsed.date.replace(/T/, ' ').replace(/Z/, ' ')} <br/>
                    Portão {userData.gate}
                  </td>
                </tr>
                </tbody>
              </Table>}

            <Table responsive striped>
              <tbody>
              <tr>
                <td>Foto</td>
              </tr>
              <tr>

                <td>
                  {userData.image !== '---' && (
                    <UserBiometryImage
                      key={userData.image + String(Date.now())}
                      imagePath={userData.image}
                      imageSide={'face'}
                    />
                  )}
                </td>
              </tr>

              <tr>
                <td>Nome</td>
              </tr>
              <tr>
                <td>{userData.name}</td>
              </tr>

              <tr>
                <td>Documento</td>
              </tr>
              <tr>
                <td>{userData.document}</td>
              </tr>

              <tr>
                <td>Data de Nascimento</td>
              </tr>
              <tr>
                <td>{userData.birthday}</td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <td></td>
              </tr>
              </tfoot>
            </Table>
            {(userData.ingPortao === currentGate && userData.supervisor === false) &&
              <Button
                disabled={disableSign}
                type="submit"
                className={`ticket-action`}

                onClick={() => {
                  setMotivation(prev => ({
                    ...prev,
                    show: true,
                    case: 0
                  }))
                }}
              >
                Gerar Acesso
              </Button>
            }

            {userData.ticketStatus === 'invalid' &&
              <Table responsive striped>
                <tbody>
                <tr className='text-center'>
                  <td>Utilização</td>
                </tr>
                <tr>
                  <td className='text-center'>
                    {userData.ticketUsed.date} - {userData.ticketUsed.time} <br/>
                    Portão {userData.ticketUsed.gate}
                  </td>
                </tr>
                </tbody>
              </Table>}
            <Card.Body>

              <Button variant="outline-primary" className='mb-0 w-100 ' onClick={() => setSearchUser('')}>Pesquisar
                Outro</Button>

            </Card.Body>

          </Card></Col>
      </Row>}

    </>

  )
}

export default SearchTicket
